import styled from 'styled-components';

export const Container = styled.div`

`;

export const ModalBody = styled.div`
    color: ${(props) => props.theme.colors.text.default};
    font-size: 1.2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .icon {
        height: 100px;
        margin-bottom: 20px;
        fill: ${(props) => props.theme.surveyManagement.bodyIcon.color};
    }
`;
